import React from 'react';
export function Footer() {
  return <footer className="bg-night" data-id="element-107" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-content px-5 py-14 text-center sm:px-8 sm:py-16" data-id="element-108" data-mp="32u0ghqxkqpao">
        <p className="font-display text-[20px] font-semibold tracking-[0.06em] text-white sm:text-[22px]" data-id="element-109" data-mp="3ghc486nrdbqc">
          ARMONÍA INTERIOR
        </p>
        <span className="mx-auto mt-5 block h-px w-16 bg-white/20" aria-hidden="true" data-id="element-110" data-mp="36oo9rik93jus" />
        <p className="mx-auto mt-5 max-w-xl text-[13px] leading-[1.75] text-white/60 sm:text-[14px]" data-id="element-111" data-mp="3ueil1vox90cx">
          Feng Shui práctico para transformar tu hogar y potenciar cada área de tu vida. Material
          digital de carácter educativo e informativo.
        </p>
        <p className="mt-8 text-[11.5px] text-white/35" data-id="element-112" data-mp="3lgop4lv2k8qa">
          © {new Date().getFullYear()} Armonía Interior · Todos los derechos reservados
        </p>
      </div>
    </footer>;
}